export type Recurrence = 'once' | 'daily' | 'weekly' | 'monthly' | 'quarterly';

export enum EmailRecurrence {
    ONCE = 'once',
    DAILY = 'daily',
    WEEKLY = 'weekly',
    MONTHLY = 'monthly',
    QUARTERLY = 'quarterly',
}

export enum FilterOption {
    DEFAULT_FILTERS_SENDER_SCOPES = 'default_filters_sender_scopes',
    SENDER_FILTERS_SENDER_SCOPES = 'sender_filters_sender_scopes',
    DEFAULT_FILTERS_RECIPIENT_SCOPES = 'default_filters_recipient_scopes',
}

export type ScheduledDashboardEmailRecipient = {
    recipientId?: number;
    externalEmail?: string;
    internalEmail?: string;
};

export type ScheduledDashboardEmail = {
    id?: number;
    senderId: number;
    sender: string;
    recipients: ScheduledDashboardEmailRecipient[];
    text: string;
    firstSentDate: string;
    recurrence: Recurrence;
    shouldSendCopyToSender: boolean;
    filterOption: FilterOption;
};

// This enum is used to track the steps in the dashboard email sending process
export enum DashboardSendEmailStepEnum {
    IDLE,
    CONFIG_FORM,
    PREVIEW,
    CONFIRMATION,
}
